import { uuid, textFormatting, contentEditable } from '@yola/ws-sdk';
import textDecorationAttributes from '../constants/text-decoration-attributes';

const {
  wrappersTypes: { decoration },
} = textFormatting.constants;

const { getSelectedElementsByTag } = contentEditable.helpers;

function getClosedDecorationIn(element, selector) {
  let targetElement = element.closest(selector);

  while (targetElement) {
    const decorationElement = targetElement.querySelector(decoration.tagName);

    if (decorationElement) {
      return decorationElement;
    }

    targetElement = targetElement.parentElement?.closest(selector);
  }

  return null;
}

const getClosestUsedDecoration = (element) => {
  const selectedElements = [...getSelectedElementsByTag(decoration.tagName)].reverse();

  if (selectedElements.length > 0) {
    return selectedElements[0];
  }

  const decorationNode = element.querySelector(decoration.tagName);

  if (decorationNode) {
    return decorationNode;
  }

  const selectorsToSearch = ['ws-text', 'ws-columns', 'ws-block', 'body'];

  return getClosedDecorationIn(element, selectorsToSearch.join(','));
};

const getInitialDecorationAttributes = (element, defaultType) => {
  const initialAttributes = {
    [textDecorationAttributes.TYPE]: defaultType,
    'unique-id': uuid(),
  };

  const nodeToReproduce = getClosestUsedDecoration(element);

  if (nodeToReproduce) {
    Object.values(textDecorationAttributes).forEach((attrName) => {
      if (nodeToReproduce.hasAttribute(attrName)) {
        initialAttributes[attrName] = nodeToReproduce.getAttribute(attrName);
      }
    });
  }

  return initialAttributes;
};

export default getInitialDecorationAttributes;
